var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seller-list"},[(_vm.tabList.length > 0)?_c('search-sort-tab',{attrs:{"tabList":_vm.tabList,"isSwitch":true},on:{"change":function($event){return _vm.$emit('changeStock', $event)},"sortProduct":_vm.sortProduct}}):_vm._e(),_c('seller-table',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }